import React from 'react'
import PropTypes from 'prop-types'
import useStore from '../../_global/jsx/store.js';
import shallow from 'zustand/shallow';
import TileOptions from '../../options-tiles/jsx/options-tiles.jsx';
import RadioOptions from '../../options-radio/jsx/options-radio.jsx';
import ButtonOptions from '../../options-buttons/jsx/options-buttons.jsx';

const OptionsType = props => {

  const { matrixData } = useStore(state =>({
    matrixData: state.matrixData,
  }), shallow);

  const optionType = matrixData['pages'][props.pageId]['options_type_display'];

  switch(optionType) {
    case 'Radio':
      return (
        <fieldset>
          <legend className="option-legend">Answer</legend>
          <RadioOptions pageId={props.pageId} />
        </fieldset>
      )
    case 'Tile': 
        return (
          <fieldset>
            <legend className="option-legend">Answer</legend>
            <TileOptions pageId={props.pageId}/>
          </fieldset>
        )
    case 'Button': 
        return (
          <fieldset>
            <legend className="option-legend">Answer</legend>
            <ButtonOptions pageId={props.pageId}/>
          </fieldset>
        )
  }
}

OptionsType.propTypes = {
  pageId: PropTypes.string
}

export default OptionsType